import { Disclosure, DisclosurePanel, DisclosureButton } from '@headlessui/react'
export type {
  DisclosureProps as HeadlessDisclosureProps,
  DisclosureButtonProps as HeadlessDisclosureButtonProps,
  DisclosurePanelProps as HeadlessDisclosurePanelProps
} from '@headlessui/react'

export const HeadlessDisclosure = Object.assign(Disclosure, {
  Panel: DisclosurePanel,
  Button: DisclosureButton
})
